import React, { type RefObject } from 'react';
import styles from '../CommandMenu.module.css';
import type Tool from '../../../tools/Tool';
import { renderToolIcon } from '../../../components/Toolbar/toolbarUtils';

const MenuItemComponent = React.forwardRef<HTMLElement | null, any>(
  function menuItemComponentWithRef(
    { item, selected }: { item: typeof Tool; selected: boolean },
    ref
  ) {
    return (
      <div
        ref={ref as RefObject<HTMLDivElement>}
        className={styles.commandMenuItem}
      >
        {renderToolIcon(item, 'fa-fw')}
        {item.toolName}
      </div>
    );
  }
);

export default MenuItemComponent;
